  function addJustOne() {
    var addIDs = document.getElementById("varsrc").dataset.vars;
    var JIDs = JSON.parse(addIDs)
    var sizeKnit = document.querySelector('input[name="size"]:checked').dataset.title;
    var dest = ''
    for(i = 0; i < JIDs.prods.length; i++){
      if(JIDs.prods[i].title == sizeKnit) {
        var dest = JIDs.prods[i].id
      }
    }
    postCart(dest,0);
    setTimeout(goToCart,1300)
    setTimeout(leaveCart,4300)
  }

function revealDropbox() {
    var addIDs = document.getElementById("varsrc").dataset.vars;
    var JIDs = JSON.parse(addIDs)
    var sizeKnit = document.querySelector('input[name="size"]:checked').dataset.title;
    var article = document.getElementById("addFormTarget");
    article.style.display = "block";
    window.location.href = '#addFormTarget'
}

 function addBoth(X) {
    var addIDs = document.getElementById("varsrc").dataset.vars;
    var JIDs = JSON.parse(addIDs)
    var sizeKnit = document.querySelector('input[name="size"]:checked').dataset.title;
    var dest = ''
    for(i = 0; i < JIDs.prods.length; i++){
      if(JIDs.prods[i].title == sizeKnit) {
        var dest = JIDs.prods[i].id
      }
    }
    postCart(dest,X);
    setTimeout(goToCart,1300)
}

function postCart(X,Y) {
if(Y == 0) {
  var formData = {
 'items': [{
  'id': X,
  'quantity': 1
  }]
};
} else {
  var formData = {
 'items': [{
  'id': X,
  'quantity': 1
  },
  {
  'id': Y,
  'quantity': 1
  }]
};
}
fetch(window.Shopify.routes.root + 'cart/add.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify(formData)
})
.then(response => {
  return response.json();
})
.catch((error) => {
  console.error('Error:', error);
});
}

function goToCart() {
  document.getElementById("secretTrigger").click();
}

function leaveCart() {
  document.getElementById("secretClose").click();
  revealDropbox()
}
